/**
 * What state an ExteLet registration is in — one answer, two watchers.
 *
 * <h3>Why this is a module</h3>
 *
 * A registration lands as PENDING_VERIFICATION and flips to VERIFIED on its own,
 * when the agent's first protected call succeeds. Nothing is pressed. So any
 * surface showing that state is showing something with a shelf life, and the
 * console's credentials card already knows this — it polls every ten seconds and
 * tears the poll down once VERIFIED arrives.
 *
 * Protect's Register step showed the same state from the commit envelope and
 * never looked again, so somebody sitting on that step read "the first call
 * verifies it" long after the first call had. Two surfaces, one fact, and only
 * one of them watching it.
 *
 * What is shared is the question: which status strings exist, what counts as
 * verified, and how often it is reasonable to ask. Not the effect — the two
 * surfaces do different things when it flips, and one of them toasts.
 */

export const REGISTRATION_STATUS = {
  PENDING: 'PENDING_VERIFICATION',
  VERIFIED: 'VERIFIED',
};

/**
 * How often to re-ask while it is pending.
 *
 * Ten seconds is the console's existing cadence. The number is here so the two
 * surfaces cannot drift into asking at different rates and reporting the same
 * flip at visibly different times.
 */
export const REGISTRATION_POLL_MS = 10_000;

/** Whether this status is one the platform will still move on its own. */
export function awaitingFirstCall(status) {
  return status === REGISTRATION_STATUS.PENDING;
}

/** Whether the first protected call has been observed. */
export function isVerified(status) {
  return status === REGISTRATION_STATUS.VERIFIED;
}
